import { TSaveColumnState } from "components/column-config-views";
import { EWorkflowStatusDataBlock } from "constants/index";
import { TBidPackageLog } from "./model";

export const ONSITE_ESTIMATE_COL_ID = "onsite_estimate_date";
export const ONSITE_ESTIMATE_DEFAULT_LABEL = "Onsite Estimate";
const DEADLINE_DATE_COL_ID = "manual_entry_date";

/**
 * A bid package takes an onsite estimate unless its Date planner is driven by linked
 * materials / submittals (no planning-only activity). Missing data counts as editable.
 */
export const isOnsiteEstimateEditable = (
  data: Pick<TBidPackageLog, "onsite_estimate_editable"> | undefined | null
) => data?.onsite_estimate_editable !== false;

export const isBidPackageCompleted = (
  data: Pick<TBidPackageLog, "workflow_status"> | undefined | null
) => data?.workflow_status === EWorkflowStatusDataBlock.WF_COMPLETED;

/**
 * Saved views / column states created before the Onsite Estimate column existed would hide it
 * (columns missing from a stored list are hidden). Insert it visible, right after Deadline Date,
 * without disturbing the stored order of the other columns.
 */
export function withOnsiteEstimateColumn(
  columnStates: TSaveColumnState
): TSaveColumnState {
  const columnList = columnStates?.columnList;
  if (!columnList?.length) return columnStates;
  if (
    columnList.some(
      (savedColumn) => savedColumn.field.name === ONSITE_ESTIMATE_COL_ID
    )
  )
    return columnStates;

  const deadlineDateColumn = columnList.find(
    (savedColumn) => savedColumn.field.name === DEADLINE_DATE_COL_ID
  );
  const lastColumnOrder = Math.max(
    ...columnList.map((savedColumn) => savedColumn.order ?? 0)
  );
  const onsiteEstimateOrder = deadlineDateColumn
    ? deadlineDateColumn.order + 0.5
    : lastColumnOrder + 1;

  return {
    ...columnStates,
    columnList: [
      ...columnList,
      {
        order: onsiteEstimateOrder,
        field: {
          name: ONSITE_ESTIMATE_COL_ID,
          agFilter: null,
          filter: null,
          sortOrder: null,
          range: null,
          width: null
        },
        visibility: true
      }
    ]
  };
}
